import { jt, t } from 'ttag'
import styled from 'styled-components'

import { SLB50S, WHITE } from '@h2/components/colors'
import { Heading } from '@h2/components/typography/heading'
import { Text } from '@h2/components/typography/text'

const ContentBox = styled.div`
  background-color: ${SLB50S};
  width: 50%;
  color: ${WHITE};
  padding: 15px;
`
const WorkValues = ({ workValues }) => {
  const firstWorkValue =
    workValues?.length > 0 ? <b key="wv1">{workValues[0]?.name}</b> : 'n/a'
  const secondWorkValue =
    workValues?.length > 1 ? <b key="wv2">{workValues[1]?.name}</b> : 'n/a'
  const thirdWorkValue =
    workValues?.length > 2 ? <b key="wv3">{workValues[2]?.name}</b> : 'n/a'
  const content = !workValues?.length
    ? t`Work values are not available for this occupation`
    : jt`People who work in this occupation generally prize ${firstWorkValue}, but also value ${secondWorkValue} and ${thirdWorkValue} in their jobs.`

  return (
    <ContentBox>
      <Heading level="3" color={WHITE}>{t`Work Values`}</Heading>
      <Text color={WHITE}>{content}</Text>
    </ContentBox>
  )
}

export { WorkValues }
